import {createReducer, on} from '@ngrx/store';
import {FakturierungsbelegColumn, FakturierungsbelegTableState} from '../states/fakturierungsbeleg-table.state';
import {FakturierungsbelegTableActions} from '../actions/fakturierungsbeleg-table.actions';
import {FakturierungsbelegEntitiesActions} from '../actions/fakturierungsbeleg-entities.actions';
import {DirectionDTO} from '../../openapi/fakturierung-openapi';


export const initialFakturierungsbelegTableState: FakturierungsbelegTableState = {
  displayedIds: [],
  tableSettings: {
    _key: 'fakturierungsbeleg-table-settings-2026-04-23-01',
    _columns: [
      {
        id: FakturierungsbelegColumn.Status,
        name: 'Status',
        isActive: true,
        sortable: false,
      }, {
        id: FakturierungsbelegColumn.BelegArt,
        name: 'Belegart',
        isActive: true,
        sortable: false,
      }, {
        id: FakturierungsbelegColumn.Faelligkeit,
        name: 'Fälligkeit',
        isActive: true,
        sortable: false,
      }, {
        id: FakturierungsbelegColumn.Belegnummer,
        name: 'Beleg-Nr.',
        isActive: true,
        sortable: false,
      }, {
        id: FakturierungsbelegColumn.Kunde,
        name: 'Kunde',
        isActive: true,
        sortable: false,
      }, {
        id: FakturierungsbelegColumn.Belegdatum,
        name: 'Beleg-Dat.',
        isActive: true,
        sortable: false,
      },
      {
        id: FakturierungsbelegColumn.Nettobetrag,
        name: 'Netto',
        isActive: true,
        sortable: false,
        alignCell: 'right',
        alignHeader: 'right',
      }, {
        id: FakturierungsbelegColumn.Bruttobetrag,
        name: 'Brutto',
        isActive: true,
        sortable: false,
        alignCell: 'right',
        alignHeader: 'right',
      }, {
        id: FakturierungsbelegColumn.Versandstatus,
        name: 'Versandstatus',
        isActive: true,
        sortable: false,
      }, {
        id: FakturierungsbelegColumn.Actions,
        name: '',
        isActive: true,
        sortable: false,
      },
    ],
    _sortDirs: [],
    _sortParams: [],
  },
  pageableDto: {
    size: 50,
    number: 0,
    property: [
      'erstellt',
    ],
    direction: [
      DirectionDTO.Desc,
    ],
  },
  totalPages: 0,
  isLoaded: false,
};

export const fakturierungsbelegTableReducer = createReducer(
  initialFakturierungsbelegTableState,

  on(FakturierungsbelegTableActions.setDisplayedIds, (state, {belegDtos}) => ({
    ...state,
    displayedIds: belegDtos.map(belegDto => belegDto.id),
  })),

  on(FakturierungsbelegTableActions.addNewItemToDisplayedIds, (state, {belegId}) => ({
    ...state,
    displayedIds: [...state.displayedIds, belegId]
  })),

  on(FakturierungsbelegTableActions.clearDisplayedFakturierungsbelege, (state) => ({
    ...state,
    displayedIds: [],
  })),

  on(
    FakturierungsbelegTableActions.changeTableSettings,
    (state, action) => ({
      ...state,
      tableSettings: action.tableSettings,
    })
  ),

  on(
    FakturierungsbelegTableActions.changePage,
    (state, action) => ({
      ...state,
      pageableDto: {
        ...state.pageableDto,
        ...action.pageableDto,
      },
    })
  ),

  on(
    FakturierungsbelegTableActions.updateSearchValue,
    (state, action) => ({
      ...state,
      filterableDto: {
        filter: action.searchValue,
      }
    })
  ),

  on(
    FakturierungsbelegEntitiesActions.countFakturierungsbelegePagesSuccess,
    (state, {totalPages}) => ({
      ...state,
      totalPages,
    })
  ),

  on(
    FakturierungsbelegEntitiesActions.readFakturierungsbelegeSuccess,
    (state) => ({
      ...state,
      isLoaded: true,
    })
  ),
);
